"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("chrono-node");
const AbstractParserWithWordBoundary_1 = require("chrono-node/dist/common/parsers/AbstractParserWithWordBoundary");
const dayjs_1 = __importDefault(require("dayjs"));
const dayjs_2 = require("chrono-node/dist/utils/dayjs");
const PATTERN = /(?:αυτ[όοήηάα]\s{0,3}τ[οηα])?\s{0,3}((?:χ[άα]ραμα|χαρ[άα]ματα)|πρω[ίι]|μεσημ[έε]ρι|απ[όο]γευμα|(?:βρ[άα]δυ|ν[ύυ]χτα)|μεσ[άα]νυχτα)(?=\W|$)/i;
class ELCasualTimeParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return PATTERN;
    }
    innerExtract(context, match) {
        const targetDate = dayjs_1.default(context.refDate);
        const component = context.createParsingComponents();
        const casualTime = match[1].toLowerCase()
        if (casualTime.match(/χ[άα]ραμα|χαρ[άα]ματα/)) {
            component.imply("meridiem", index_1.Meridiem.AM);
            component.imply("hour", 4);
        } else if (casualTime.match(/πρω[ίι]/)) {
            component.imply("meridiem", index_1.Meridiem.AM);
            component.imply("hour", 8);
        } else if (casualTime.match(/μεσημ[έε]ρι/)) {
            component.imply("meridiem", index_1.Meridiem.PM);
            component.imply("hour", 12);
        } else if (casualTime.match(/απ[όο]γευμα/)) {
            component.imply("meridiem", index_1.Meridiem.PM);
            component.imply("hour", 16);
        } else if (casualTime.match(/βρ[άα]δυ|ν[ύυ]χτα/)) {
            component.imply("meridiem", index_1.Meridiem.PM);
            component.imply("hour", 20);
        } else if (casualTime.match(/μεσ[άα]νυχτα/)) {
            dayjs_2.assignTheNextDay(component, targetDate);
            component.imply("hour", 0);
            component.imply("minute", 0);
            component.imply("second", 0);
        }
        return component;
    }
}
exports.default = ELCasualTimeParser;
